export default __webpack_public_path__ + "static/belastingdienst-ff163cc31e57104f88cbc8147afd361f9e7f7225ec1459f1238809b070a3e60d.svg";